/**
 * Converts a numeric confidence level (1–5) to a display string.
 * 1–3: low, 4: medium, 5: high.
 */
export function confidenceLevelToRating(
  level: number | null | undefined,
): 'low' | 'medium' | 'high' | undefined {
  if (level == null) {
    return undefined;
  }
  switch (level) {
    case 1:
    case 2:
    case 3:
      return 'low';
    case 4:
      return 'medium';
    case 5:
      return 'high';
    default:
      return undefined;
  }
}
